module.exports = __webpack_public_path__ + "static/media/empty-state-workpacks.0a54f2d0.svg";